import { __decorate } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { InjectorService } from '@tencent/ioc';

/**
 * 功能开关服务
 *
 * @public
 */
let FeatureFlagService = class FeatureFlagService {
    constructor() {
        this.flags = {};
    }
    /**
     * 设置开关
     *
     * @param name - Feature/Controller 名称
     * @param flag - Feature/Controller 开关
     */
    setFlag(name, flag) {
        this.flags[name] = flag;
    }
    /**
     * 获取开关
     *
     * @param name - Feature/Controller 名称
     */
    getFlag(name) {
        var _a;
        return (_a = this.flags[name]) !== null && _a !== void 0 ? _a : true;
    }
};
FeatureFlagService = __decorate([
    Service({ overridable: true })
], FeatureFlagService);
InjectorService.factory(FeatureFlagService, new FeatureFlagService());

export { FeatureFlagService };
//# sourceMappingURL=feature-flag-service.js.map
